import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as SessionActions from 'web-app/react/entities/sessions/actions';

import * as Actions from './actions';
import * as Constants from './constants';

const SessionModalState = Record({
    institutionId: '',
    sessionType: '',
    sessionId: '',
    sessionVersion: '',
    canSetBillOnChildSick: false,
    canSetBillOnChildAbsent: false,
    showSessionVersions: false,
    newVersionAdded: false,
    isVisible: false,
    didFetchSession: false,
    closingDayOptions: null,
    allowFundable: false,
    showWeekends: false,
    isSubmitting: false,
    showWeekdays: false,
    customFte: null,
});

export default handleActions(
    {
        [Actions.showExisting.type]: (state, {payload}) =>
            SessionModalState({
                isVisible: true,
                closingDayOptions: payload.sessionClosingDayOptions,
                canSetBillOnChildSick: payload.canSetBillOnChildSickOnSessions,
                canSetBillOnChildAbsent: payload.canSetBillOnChildAbsentOnSessions,
                allowFundable: payload.allowFundableSessions,
                showWeekends: payload.showSessionsInWeekends,
                institutionId: payload.session.institutionId,
                sessionType: payload.session.sessionType,
                sessionId: payload.session.sessionId,
                showWeekdays: true,
                showSessionVersions: true,
                customFte: payload.session.customFte,
            }),

        [Actions.showSessionVersions.type]: (state, {payload}) =>
            state.merge({
                showSessionVersions: payload.show,
            }),

        [Actions.changeVersion.type]: (state, {payload}) =>
            state.merge({
                sessionVersion: payload.newVersion,
            }),

        [Actions.newVersion.type]: state =>
            state.merge({
                newVersionAdded: true,
                sessionVersion: Constants.newVersionId,
            }),

        [Actions.showNew.type]: (state, {payload}) =>
            new SessionModalState({
                isVisible: true,
                closingDayOptions: payload.sessionClosingDayOptions,
                canSetBillOnChildSick: payload.canSetBillOnChildSickOnSessions,
                canSetBillOnChildAbsent: payload.canSetBillOnChildAbsentOnSessions,
                allowFundable: payload.allowFundableSessions,
                showWeekends: payload.showSessionsInWeekends,
                institutionId: payload.institutionId,
                sessionType: payload.sessionType,
                sessionId: null,
                sessionVersion: Constants.newVersionId,
                customFte: null,
            }),

        [SessionActions.fetchSuccess.type]: state => state.merge({didFetchSession: true}),

        [SessionActions.create.type]: state => state.merge({isSubmitting: true}),
        [SessionActions.update.type]: state => state.merge({isSubmitting: true}),
        [SessionActions.remove.type]: state => state.merge({isSubmitting: true}),
        [SessionActions.restore.type]: state => state.merge({isSubmitting: true}),

        [SessionActions.updateAborted.type]: state => state.merge({isSubmitting: false}),
        [SessionActions.removeAborted.type]: state => state.merge({isSubmitting: false}),
        [SessionActions.restoreAborted.type]: state => state.merge({isSubmitting: false}),

        [SessionActions.createFailed.type]: state => state.merge({isSubmitting: false}),
        [SessionActions.updateFailed.type]: state => state.merge({isSubmitting: false}),
        [SessionActions.removeFailed.type]: state => state.merge({isSubmitting: false}),
        [SessionActions.restoreFailed.type]: state => state.merge({isSubmitting: false}),

        [Actions.hide.type]: () => new SessionModalState(),
        [SessionActions.createSuccess.type]: () => new SessionModalState(),
        [SessionActions.updateSuccess.type]: () => new SessionModalState(),
        [SessionActions.removeSuccess.type]: () => new SessionModalState(),
        [SessionActions.restoreSuccess.type]: () => new SessionModalState(),

        [Actions.toggleWeekdays.type]: state =>
            state.merge({
                showWeekdays: !state.showWeekdays,
            }),

        [SessionActions.unscheduleSuccess.type]: (state, {payload}) => {
            if (payload.last) {
                return new SessionModalState();
            } else {
                return state.merge({sessionVersion: null});
            }
        },
    },
    SessionModalState(),
);
